import ButtonComponent from '../../../Buttons/ButtonComponent';

import data from '../../../../data/brokers/pricingBrokers';

import Styles from '../styles.module.scss';

const BrokersPricingCard = (props) => (
  <div className={Styles['flex-wrapper']}>
    {data.map((item) => (
      <div className={Styles.card} key={item.id}>
        <h5>{item.title}</h5>
        <div className={Styles.column}>
          <div className={Styles['internal-column']}>
            <p>{item.text}</p>
            {(item.button && (
              <ButtonComponent
                clickHandler={(e) => { e.preventDefault(); props.goToContactForm(); }}
                value="Contact Us"
                path=""
                short
              />
            )) || ((item.price === 'Free' && (
              <span className={Styles.price}>
                {item.price}
              </span>
            )) || (
              <span className={Styles.price}>
                <small>from</small>
                {' '}
                {item.price}
                {' '}
                <small>/mo</small>
              </span>
            ))}
          </div>
          <div className={Styles['internal-column']}>
            <h6>API Call Limits</h6>
            <div className={Styles.desc}>
              <span>{item.call_limits.calls}</span>
              calls /
              {' '}
              {item.price === 'Free' ? 'hour' : 'month'}
            </div>
            <div className={Styles.desc}>
              <span>{item.call_limits.stories}</span>
              stories / response
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>
);

export default BrokersPricingCard;
